<template>
	<div class="pageBox">
		<Header current='souye' ref="Header" ></Header>
		<div class="pageBox_cen" >
			<!-- <video :src="'https://aohuacbi.oss-cn-qingdao.aliyuncs.com/20230605092859/2023%E6%BE%B3%E5%8D%8E%E5%93%81%E7%89%8C%E5%AE%A3%E4%BC%A0%E7%89%87-%E5%8E%8B%E7%BC%A9%E7%89%88.mp4'" :autoplay="true" muted loop></video> -->
			<template v-for="(item,index) in list">
				<component :is="mapComponent[item.name]" :list='item' :ref="item.name" />
			</template>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/header.vue"
	import Footer from "@/components/footer.vue"
	import mapComponent from "@/components/mapComponent.js";
	import {
		get_banner,
		get_home_product,
		get_news,
		get_core_tec
	} from "@/api/index.js"
	export default {
		components: {
			Header,
			Footer,
		},
		data() {
			return {
				mapComponent,
				list: [{
						name: 'indexBanner',
						value: '首页轮播图',
					}, {
						name: 'indexCanpin',
						value: '首页产品',
					},
					{
						name: 'indexHexin',
						value: '首页核心',
					},
					{
						name: 'indexAbout',
						value: '关于澳华',
					},
					{
						name: 'indexNews',
						value: '新闻中心',
					},
				]
			}
		},
		mounted() {
			let t = this;
			// 获取首页轮播图
			t.getBannerList(1);
			// 获取首页核心 轮播图
			t.getBannerList(17);
			// 获取首页关于澳华 轮播图
			t.getBannerList(8);
			// 获取产品
			t.getProduct();
			// 获取新闻列表
			t.getNews();
			// 获取核心技术
			// t.getCore();
			
			window.addEventListener('scroll', this.handleScroll);
			 this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
			this.$watch('$route', this.onRouteChange);
			var element;
			if(this.nowVibe=='pc'){
				element= document.documentElement
			}else{
				element = document.documentElement.scrollTop ? document.documentElement : document.body;
			}
			let scrollTop = element.scrollTop;
			if(scrollTop==0){
				this.$refs.Header.headerHover = false;
				this.$refs.Header.headerTrue = false;
			}else{
				this.$refs.Header.headerTrue = true;
				this.$refs.Header.headerHover = true;
			}
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
			
		},
		methods: {
			handleScroll() {
				const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
					.scrollTop || 0;
				if (currentScrollTop > this.lastScrollTop) {
					this.navHidden = true;
				} else {
					this.navHidden = false;
				}
				this.lastScrollTop = currentScrollTop;
				this.$refs.Header.navHidden = this.navHidden;
				if(currentScrollTop==0){
					if(!this.$refs.Header.navHead){
						this.$refs.Header.headerHover = false;
					}
					this.$refs.Header.headerTrue = false;
				}else{
					this.$refs.Header.headerTrue = true;
					this.$refs.Header.headerHover = true;
				}
			},
			// 获取首页轮播图
			getBannerList(e) {
				let t = this;
				let data = {
					module: e
				}

				get_banner(data).then((res) => {
					console.log(res)
					this.$nextTick(function() {
						if (e == 1) {
							t.$refs['indexBanner'][0].setList(res.data);
						}
						else if (e == 17) {
							// t.$refs['indexHexin'][0].setList(res.data);
							t.$refs['indexHexin'][0].setList(res.data);
						} 
						else if (e == 8) {
							t.$refs['indexAbout'][0].setList(res.data);
						}
					})
				}).catch((err) => {
					console.log(err)
				})
			},
			// 获取首页产品
			getProduct() {
				let t = this;
				let data = {

				}
				get_home_product(data).then((res) => {
					this.$nextTick(function() {
						t.$refs['indexCanpin'][0].swiperList = res.data;
					})
				}).catch((err) => {
					console.log(err)
				})
			},
			// 获取新闻列表
			getNews(){
				let t = this;
				let data={
					// limit:4,
					// page:1
				}
				get_news(data).then(res=>{
					console.log(res,"新闻")
					this.$nextTick(function() {
						t.$refs['indexNews'][0].setList(res.data);
					})
				}).catch(err=>{
					console.log(err)
				})
			},
			// 获取核心技术
			getCore(){
				let t = this;
				let data={}
				get_core_tec(data).then(res=>{
					console.log(res,"核心技术")
					this.$nextTick(function() {
						t.$refs['indexHexin'][0].setList(res.data.list);
					})
				}).catch(err=>{
					console.log(err)
				})
			},
			
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.pageBox {
		display: flex;
		flex-direction: column;
		min-height: 100vh;

		.pageBox_cen {
			flex: 1;
		}
	}
</style>